export default Object.freeze({
    GIFT_CARDS_PATH: "/list/e1f424bc-d355-420c-9900-55c0b42ebc6f",
});
